var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPervjetoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.577,
    height: 19.577,
    viewBox: "0 0 20.577 19.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5746",
    "data-name": "Group 5746",
    transform: "translate(-1212.651 -447.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5739",
    "data-name": "Group 5739",
    transform: "translate(1210 446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5738",
    "data-name": "Group 5738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5737",
    "data-name": "Group 5737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8279",
    "data-name": "Path 8279",
    d: "M3.99,21.29l9.04-3.23a2,2,0,0,0,.74-3.3L9.24,10.23a2,2,0,0,0-3.3.74L2.71,20.01A1,1,0,0,0,3.99,21.29Z",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8280",
    "data-name": "Path 8280",
    d: "M15.06,12l5.06-5.06a1.249,1.249,0,0,1,1.77,0l.06.06a.754.754,0,0,0,1.06,0h0a.754.754,0,0,0,0-1.06l-.06-.06a2.758,2.758,0,0,0-3.89,0L14,10.94A.754.754,0,0,0,14,12h0A.754.754,0,0,0,15.06,12Z",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8281",
    "data-name": "Path 8281",
    d: "M10.06,6.88,10,6.94A.754.754,0,0,0,10,8h0a.754.754,0,0,0,1.06,0l.06-.06a2.758,2.758,0,0,0,0-3.89L11.07,4A.749.749,0,0,0,10,4h0a.754.754,0,0,0,0,1.06l.06.06A1.256,1.256,0,0,1,10.06,6.88Z",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8282",
    "data-name": "Path 8282",
    d: "M17.06,11.88,16,12.94A.754.754,0,0,0,16,14h0a.754.754,0,0,0,1.06,0l1.06-1.06a1.249,1.249,0,0,1,1.77,0l1.08,1.08a.754.754,0,0,0,1.06,0h0a.754.754,0,0,0,0-1.06l-1.08-1.08A2.758,2.758,0,0,0,17.06,11.88Z",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8283",
    "data-name": "Path 8283",
    d: "M15.06,5.88,12,8.94A.754.754,0,0,0,12,10h0a.754.754,0,0,0,1.06,0l3.06-3.06a2.758,2.758,0,0,0,0-3.89L15.06,1.99a.754.754,0,0,0-1.06,0h0a.754.754,0,0,0,0,1.06l1.06,1.06A1.268,1.268,0,0,1,15.06,5.88Z",
    fill: "#1d3943"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPervjetoreIcon);
export default __webpack_public_path__ + "static/media/pervjetore_icon.c1bd40c68cc8c4e79882edc5214dcfc1.svg";
export { ForwardRef as ReactComponent };